// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Warhammer 40,000 Universe - Warp Gates Configuration
 * 
 * Warp rifts connecting to other universes
 */

export const warpGates = [
  {
    id: 'gate-warhammer40k-halo',
    name: 'Warp Rift Epsilon',
    type: 'warpgate',
    distance: 20,
    fromUniverse: 'warhammer40k',
    destinationUniverse: 'halo',
    fromSystem: 1100,
    toSystem: 1800,
    destinationGate: 'gate-halo-warhammer40k',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'HIGH',
    resources: 'WARP RIFT',
    services: [],
    primaryColor: '#ff00ff',
    secondaryColor: '#00ff00',
    hasRings: true,
    discovered: true,
    description: 'Warp rift to UNSC space. Slipspace and Warp energies clash.'
  },
  {
    id: 'gate-warhammer40k-dungeon-dimensions',
    name: 'Warp Rift Zeta',
    type: 'warpgate',
    distance: 22,
    fromUniverse: 'warhammer40k',
    destinationUniverse: 'dungeon-dimensions',
    fromSystem: 1100,
    toSystem: 500,
    destinationGate: 'gate-dungeon-dimensions-warhammer40k',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'EXTREME',
    resources: 'WARP RIFT',
    services: [],
    primaryColor: '#ff00ff',
    secondaryColor: '#ff0000',
    hasRings: true,
    discovered: false,
    description: 'Warp rift to Dungeon Dimensions. Chaos and narrative causality merge.'
  },
  {
    id: 'gate-warhammer40k-masseffect',
    name: 'Warp Rift Theta',
    type: 'warpgate',
    distance: 25,
    fromUniverse: 'warhammer40k',
    destinationUniverse: 'masseffect',
    fromSystem: 1100,
    toSystem: 900,
    destinationGate: 'gate-masseffect-warhammer40k',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'HIGH',
    resources: 'WARP RIFT',
    services: [],
    primaryColor: '#ff00ff',
    secondaryColor: '#00d4ff',
    hasRings: true,
    discovered: false,
    description: 'Warp rift to Citadel space. Immaterium and Element Zero fields interact dangerously.'
  }
];

export const warpGatePositions = {
  'gate-warhammer40k-halo': { x: 62, y: 48, z: 5 },
  'gate-warhammer40k-dungeon-dimensions': { x: 38, y: 52, z: -4 },
  'gate-warhammer40k-masseffect': { x: 50, y: 60, z: 8 }
};
